import { Badge } from 'react-bootstrap'

const COLORS: Record<string, string> = {
  APPROVED: 'success',
  APPROVED_MANUALLY: 'success',
  APPROVED_DISCREPANCY: 'success',
  APPROVED_MANUALLY_DISCREPANCY: 'success',
  NOT_FOUND: 'danger',
}

const LABELS: Record<string, string> = {
  APPROVED: 'Approved',
  APPROVED_MANUALLY: 'Approved (Manually)',
  APPROVED_DISCREPANCY: 'Approved (Discrepancy)',
  APPROVED_MANUALLY_DISCREPANCY: 'Approved (Manually Discrepancy)',
  NOT_FOUND: 'Not found',
}

export const BadgeStatus = ({ state }: { state: string }) => {
  const color = COLORS[state] || 'secondary'
  const label = LABELS[state] || state

  return <Badge bg={color}>{label}</Badge>
}
